import type { Locale } from "@/stores/ui-store";
import enMessages from "./messages/en.json";
import deMessages from "./messages/de.json";

type Nested = { [key: string]: string | Nested };

function flatten(input: Nested, prefix = ""): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(input)) {
    const next = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "string") {
      out[next] = value;
    } else {
      Object.assign(out, flatten(value, next));
    }
  }
  return out;
}

const RAW = {
  en: enMessages as Nested,
  de: deMessages as Nested,
} as const;

export function messagesForLocale(locale: string): { locale: Locale; messages: Record<string, string> } {
  const normalized = locale === "de" ? "de" : "en";
  return { locale: normalized, messages: flatten(RAW[normalized]) };
}
